<template>
  <v-app>
    <v-main style="overflow: hidden !important;">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
